<div class="chips-container">
    @for (chip of chipsData(); track $index) {
    <div (click)="onPress.emit($index)" class="chips-container__item" [ngClass]="{'plotBand-hidden': !chip.show}" [title]="chip.label">
        <div class="filled-circle" [style.background]="chip.color"></div>
        <span>{{chip.label}}</span>
    </div>
    }
</div>